import { Controller } from "stimulus";


export default class extends Controller {
    static targets = ["draftImage", "bottleImage", "canImage"];

    connect() {
        this.checkBeerType();
    }

    checkBeerType() {
        var hrefID = "";

        //URL
        if (window.location.href.indexOf('?') > -1) {
            hrefID = window.location.href.split("?")[1];
        }
        if (hrefID.indexOf('&locale=') > -1) {
            hrefID = hrefID.split('&locale=')[0]
        }

        if (hrefID != null && hrefID.length) {

            if (hrefID == "spina")
            {
                //se la birra è alla spina, nascondo immagini di birra in bottiglia e lattina
                if (this.hasBottleImageTarget) {
                    this.bottleImageTarget.style.display = "none";
                }
                if (this.hasCanImageTarget) {
                    this.canImageTarget.style.display = "none";
                }
            } else if (hrefID == "bottiglia")
            {
                //se la birra è in bottiglia, nascondo immagini di birra alla spina e in lattina
                if (this.hasDraftImageTarget) {
                    this.draftImageTarget.style.display = "none";
                }
                if (this.hasCanImageTarget) {
                    this.canImageTarget.style.display = "none";
                }
            } else if (hrefID == "lattina")
            {
                //se la birra è in lattina, nascondo immagini di birra alla spina e in bottiglia
                if (this.hasDraftImageTarget) {
                    this.draftImageTarget.style.display = "none";
                }
                if (this.hasBottleImageTarget) {
                    this.bottleImageTarget.style.display = "none";
                }
            }
        }
    }

    get mainController() {
        return this.application.getControllerForElementAndIdentifier(document.querySelector('body'), "main");
    }
}

